
import { useState } from "react";

export const useNotesTagsDialogs = () => {
  const [isManageNotesOpen, setIsManageNotesOpen] = useState(false);
  const [isManageTagsOpen, setIsManageTagsOpen] = useState(false);


  return {
    isManageNotesOpen,
    isManageTagsOpen,
    setIsManageNotesOpen,
    setIsManageTagsOpen,
  };
};